import { formatTicker } from '@api/mappers/formatTicker';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { ThemeChartLogo } from '@terminal/components/theme-search-logo/ThemeChartLogo';
import { isThemeChartEntity } from '@terminal/views/turbo-chart/utils/chart-theme-asset/chartThemeAsset';
import type { TerminalChartEntity } from '@terminal/views/turbo-chart/utils/chart-utils/types';
import clsx from 'clsx';

import styles from './AssetTickerLabel.module.scss';

const LOGO_SIZE = 20;

export interface AssetTickerLabelProps {
  entity: TerminalChartEntity;
}

const AssetTickerLogo = ({ entity }: { entity: TerminalChartEntity }) => {
  if (isThemeChartEntity(entity)) {
    return <ThemeChartLogo tag={entity.tag} name={entity.name} size={16} />;
  }

  const {
    formattedTicker: _formattedTicker,
    logo: _logo,
    ...assetEntity
  } = entity;

  return <AssetLogoContainer entity={assetEntity} size={LOGO_SIZE} />;
};

export const AssetTickerLabel = ({ entity }: AssetTickerLabelProps) => {
  const ticker = isThemeChartEntity(entity)
    ? entity.name
    : (
        entity.formattedTicker ||
        formatTicker(entity) ||
        entity.name
      ).toUpperCase();

  return (
    <span className={styles.root}>
      <span className={styles.logoSlot} aria-hidden>
        <AssetTickerLogo entity={entity} />
      </span>
      <span
        className={clsx(styles.ticker, {
          [styles.isUpperCase]: !isThemeChartEntity(entity),
        })}
      >
        {ticker}
      </span>
    </span>
  );
};
